import { IFertiliserAnalysis, INutritionPlanProductApp } from "../types";

export function getApplicationAnalysis(app: INutritionPlanProductApp): IFertiliserAnalysis {

    if (app.Manure) {
        if (app.Manure.Custom) return app.Manure;
        return app.Manure.NvzManureType || app.Manure.ManureType;
    }

    if (app.Fertiliser) {
        if (app.Fertiliser.Custom) return app.Fertiliser;
        return app.Fertiliser.StandardProduct;
    }

}
